import NewDependencyRow from './newDependencyRow';

export default NewDependencyRow;
